import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import MissionForm from '../Form';
import { createMission } from '@resources/Mission/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createMission, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createMission(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.mission.create',
						defaultMessage:
							'A new Mission has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.mission',
					defaultMessage: 'Create Mission',
				})}
			</Title>
			<MissionForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createMission })(Create);
